import React, { forwardRef } from 'react';
import { type Input as BaseInput } from 'tamagui';

import { formatTextInputAsDate } from '../../utils/dateUtils';
import { Input, type InputProps } from './Input';

export interface DateInputProps extends Omit<
    InputProps,
    'onChangeText' | 'value' | 'rightIcon'
> {
    value?: string;
    onChangeText?: (formattedValue: string) => void;
}

export const DateInput = forwardRef<BaseInput, DateInputProps>(
    (
        {
            value = '',
            onChangeText,
            placeholder = 'MM/DD/YYYY',
            inputMode = 'numeric',
            keyboardType = 'number-pad',
            autoComplete = 'off',
            ...props
        },
        ref,
    ) => {
        const handleChangeText = (text: string) => {
            const previousValue = value || '';
            const formattedValue = formatTextInputAsDate(previousValue, text);
            onChangeText?.(formattedValue);
        };

        return (
            <Input
                ref={ref}
                value={value}
                onChangeText={handleChangeText}
                placeholder={placeholder}
                inputMode={inputMode}
                keyboardType={keyboardType}
                autoComplete={autoComplete}
                maxLength={10}
                {...props}
            />
        );
    },
);
